import { LeadType } from './lead.type.model';

export class LeadTypeResponse {
  leadTypeList: LeadType[];

  constructor(leadTypeList: any) {
    this.leadTypeList = leadTypeList;
  }
}
